/**
 * Pages the owner has hidden: no menu row, and a link to one only lands on the start page (it has no route, or, for
 * the Dashboard's "/", a redirect) or, for /mmm, on /budget, the page that replaced it. Box 7 keeps the items such a
 * page raised, but no box, chat or file points at the page (rules-04 D review I3). /looker is not one: it keeps its
 * route while its menu row waits for Looker.
 *
 * @module services/hiddenPages
 */

/** Each hidden page's path (owner); drop one here when it is routed again. */
const HIDDEN_PATHS: readonly string[] = [
  '/', // the Dashboard (pages/Home), since 2026-10-15
  '/campaigns', // Media Intelligence, since 2026-10-16
  '/insights', // Insights, since 2026-10-16
  '/mmm', // MMM Analysis (pages/MMMDetail), since 2026-10-30; its route redirects to /budget (D5 R22)
];

/** The page a link opens, without its query or anchor: "/insights#e1" → "/insights". */
const pathOf = (link: string): string => link.split(/[?#]/)[0];

/** A hidden page or a page under it; the Dashboard's "/" matches only itself, never every page. */
export const isHiddenPage = (link: string): boolean => {
  const path = pathOf(link);
  return HIDDEN_PATHS.some((p) => path === p || (p !== '/' && path.startsWith(`${p}/`)));
};
